module.exports = __webpack_public_path__ + "static/img/bus-words.5c5147a0.png";